<template>
  <div>
    <!-- 저장하기 -->
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="saveData">저장하기</button>
    </div>
    <div class="columns is-multiline">
      <div class="column is-full">
        <div class="box">
          <admin-box-item title="카카오 알림톡 템플릿 설정"
                          :useTab="false">
            <div style="margin-bottom: 24px">
              <div class="desc">템플릿 내용: cool sms에서 카카오 알림톡 템플릿 등록할 때
                템플릿 내용을 복사해서 붙여 넣으세요.</div>
              <div class="desc">Sender Key: 알림톡 템플릿의 등록이 완료가 되면 Sender Key를 복사하여 저장해주세요.</div>
              <div class="desc">Template Code: 알림톡 템플릿의 등록이 완료가 되면 Template Code를 복사하여 저장해주세요.</div>
            </div>
            <div class="column is-full temp-wrapper" v-for="(item, temp_idx) in temp_list" :key="`temp-${temp_idx}`">
              <admin-form-item label="템플릿 제목">
                <div>{{ item.temp_type_kor }}</div>
              </admin-form-item>
              <admin-form-item label="템플릿 내용">
                <div style="white-space:pre-line;">{{ item.temp_message }}</div>
              </admin-form-item>
              <admin-form-item label="Sender Key" desc="API v2 이하 버전 전용 파라미터">
                <input class="input"
                       style="width:340px"
                       :value="item.sender_key"
                       @input="e=> item.sender_key = e.target.value"
                       type="text">
              </admin-form-item>
              <admin-form-item label="Template Code" desc="API v2 이하 버전 전용 파라미터">
                <input class="input"
                       style="width:340px"
                       :value="item.template_code"
                       @input="e=> item.template_code = e.target.value"
                       type="text">
              </admin-form-item>

              <admin-form-item label="pfId">
                <input class="input"
                       style="width:340px"
                       :value="item.pfId"
                       @input="e=> item.pfId = e.target.value"
                       type="text">
              </admin-form-item>
              <admin-form-item label="templateId">
                <input class="input"
                       style="width:340px"
                       :value="item.templateId"
                       @input="e=> item.templateId = e.target.value"
                       type="text">
              </admin-form-item>

              <admin-form-item label="알림톡 버튼 목록">
                <div class="flex" style="border-bottom:1px solid #ddd;padding-bottom:12px">
                  <div style="width:25%">버튼이름</div>
                  <div style="width:10%">버튼종류</div>
                  <div style="width:65%">버튼링크</div>
                </div>
                <div class="flex" style="border-bottom:1px solid #ddd;padding:12px 0" v-for="(button, b_idx) in item.buttons" :key="`button-${b_idx}`">
                  <div style="width:25%;padding:6px">
                    <input class="input"
                           style="width:340px"
                           :value="button.buttonName"
                           @input="e=> button.buttonName = e.target.value"
                           type="text">
                  </div>
                  <div style="width:10%;padding:6px">{{ button.buttonType==='WL'?'웹링크':button.buttonType }}</div>
                  <div style="width:65%;padding:6px">
                    <div class="flex-align" style="margin-bottom: 8px">
                      <div style="width:80px;margin-right: 4px">모바일링크</div>
                      <input class="input"
                             :value="button.linkPc"
                             @input="e=> button.linkPc = e.target.value"
                             type="text">
                    </div>
                    <div class="flex-align">
                      <div style="width:80px;margin-right: 4px">PC링크</div>
                      <input class="input"
                             :value="button.linkMo"
                             @input="e=> button.linkMo = e.target.value"
                             type="text">
                    </div>
                  </div>
                </div>
                <button class="button" style="margin-top:12px" @click="addAtaButton(item)">알림톡 버튼 추가</button>
              </admin-form-item>

              <div style="margin: 12px 0">
                <toggle-button @change="e=> item.enable= e.value" :sync="true"
                               :value="item.enable" class="changed-font" :width="70" :height="24"
                               :labels="{'checked':'사용', 'unchecked':'사용 안 함'}"></toggle-button>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "KakaoMessageTemplateSetting",
    data () {
      return {
        temp_list: undefined
      }
    },
    created () {
      this.getData();
    },
    methods: {
      addAtaButton(item) {
        let data = {
          buttonType: 'WL',
          buttonName: '',
          linkMo: '',
          linkPc: ''
        }
        item.buttons.push(data)
      },
      getData () {
        this.$axios.get('admin/kakao/message_template').then(res => {
          this.temp_list = res.data;
        })
      },
      saveData () {
        this.$axios.post('admin/kakao/message_template', this.temp_list).then(res => {
          if(res.status===200) {
            this.toast('저장되었습니다.');
          }
        }).catch(error=>{
          this.toast('서버에 오류가 발생했습니다. 관리자에게 문의주세요.');
        });
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  .temp-wrapper
    border 1px solid #eee
    border-bottom 0

  .temp-wrapper:last-child
    border 1px solid #eee

  .desc
    font-size 0.8rem
    margin-top 4px
    color #787878
</style>
